//#region portal store connector
// because desktop and mobile have different "Portal Store" implementations.

/**
 * Common API between different various shared code and different Portal Store (desktop vs mobile) implementations.
 */
let portalStoreConnector = {
  showEmptyPage: (_arePageContentsEmpty?: boolean) => {},
  onPageAreaSizeChange: () => {},
  updatePageName: (_pageName: string) => {},
  isFolderTreeInitialized: () => false,
};

export function setPortalStoreConnector(connector: typeof portalStoreConnector) {
  portalStoreConnector = connector;
  //
  Object.freeze(portalStoreConnector);
}

export function getPortalStoreConnector() {
  return portalStoreConnector;
}

//#endregion portal store connector
